import { render, staticRenderFns } from "./PieChartType.vue?vue&type=template&id=feb32baa&scoped=true&"
import script from "./PieChartType.vue?vue&type=script&lang=js&"
export * from "./PieChartType.vue?vue&type=script&lang=js&"
import style0 from "./PieChartType.vue?vue&type=style&index=0&id=feb32baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb32baa",
  null
  
)

export default component.exports